<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form
        layout="inline"
        @submit="handleSearch"
        :autoFormCreate="
          (form) => {
            this.searchForm = form;
          }
        "
      >
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="指定时间点" fieldDecoratorId="date_time">
              <a-date-picker
                show-time
                format="YYYY-MM-DD HH:mm:ss"
                placeholder="指定时间点"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="所属门店" fieldDecoratorId="branch_id">
              <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                <a-select-option v-for="item in branches" :key="item.id">{{
                  item.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="7天内未盘点" fieldDecoratorId="is_long_time_inspect">
              <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                <a-select-option :key="1">是</a-select-option>
                <a-select-option :key="2">否</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="是否异常" fieldDecoratorId="is_abnormal">
              <a-select placeholder="请选择" allowClear>
                <a-select-option :key="1">是</a-select-option>
                <a-select-option :key="2">否</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="上架状态" fieldDecoratorId="is_listing">
              <a-select placeholder="请选择" allowClear>
                <a-select-option :key="1">上架</a-select-option>
                <a-select-option :key="2">未上架</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" htmlType="submit">查询</a-button>
              <a-divider type="vertical" />
              <a-button style="margin-left: 8px" @click="handleExport"
                >导出</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- <div class="table-operator">
      <a-button type="primary" @click="handleSelect">复盘</a-button>
    </div> -->
    <s-table ref="table" size="default" :columns="columns" :data="loadData">
      <template slot="no" slot-scope="text">
        pd{{text.toString().padStart(8,"0")}}
      </template>
      <template slot="name" slot-scope="text, record">
        <p>{{ text }}</p>
        <p>{{ record.sku.attribute }}</p>
      </template>
      <template slot="action" slot-scope="text, record">
        <div class="editable-row-operations">
          <a @click="handleChange(record)">修改盘点数量</a>
        </div>
      </template>
    </s-table>
    <a-modal
      title="盘点数量"
      :visible="visible"
      @ok="_handleOk"
      @cancel="handleCancel"
      :maskClosable="false"
    >
      <a-input v-model.number="currentRecord.difference" />
    </a-modal>
  </a-card>
</template>
<script>
import moment from 'moment'
import STable from "@/components/table/";
import AInput from "ant-design-vue/es/input/Input";
import { Inventory, getStocksCheckList } from "@/api/stock";
import { getBranchList } from "@/api/branch";
import { encodeJsonToQuery } from "@/utils/util";
import { ACCESS_TOKEN } from "@/store/mutation-types";

export default {
  name: "InventoryList",
  components: {
    AInput,
    STable,
  },
  data() {
    return {
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: null,
      mdl: {},
      // 查询参数
      searchForm: null,
      branches: [],
      differ: 0,
      queryParam: {},
      columns: [
        {
          title: "盘点记录号",
          dataIndex: "id",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "商品名称",
          dataIndex: "goods_name",
        },
        {
          title: "门店",
          dataIndex: "branch_name",
        },
        {
          title: "指定时间点库存",
          dataIndex: "remainder",
        },
        {
          title: "盘点前库存",
          dataIndex: "stock_num",
        },
        {
          title: "盘点数量",
          dataIndex: "check_num",
        },
        {
          title: "提交时间",
          dataIndex: "created",
        },
        {
          title: "库存减少",
          dataIndex: "out",
        },
        {
          title: "库存增加",
          dataIndex: "in",
        },
        {
          title: "异常数量",
          dataIndex: "abnormal_num",
        },
        {
          title: "操作人",
          dataIndex: "admin_user_name",
        },
        // {
        //   title: "操作",
        //   dataIndex: "action",
        //   scopedSlots: { customRender: "action" },
        // },
      ],
      currentRecord: {},
      // 加载数据方法 必须为 Promise 对象
      loadData: (params) => {
        return getStocksCheckList(Object.assign(params, this.queryParam)).then(
          (res) => res
        );
      },
    };
  },
  created() {
    this.getBranchList();
  },

  methods: {
    getBranchList: function () {
      getBranchList().then((res) => {
        this.branches = res.list;
      });
    },
    handleSearch(e) {
      e.preventDefault();
      let dateTime = this.searchForm.getFieldValue("date_time")
      this.queryParam = {
        date_time: dateTime && dateTime.format('YYYY-MM-DD HH:mm:ss'),
        branch_id: this.searchForm.getFieldValue("branch_id"),
        is_listing: this.searchForm.getFieldValue("is_listing"),
        is_long_time_inspect: this.searchForm.getFieldValue("is_long_time_inspect"),
        is_abnormal: this.searchForm.getFieldValue("is_abnormal"),
      };
      this.$refs.table.refresh();
    },
    handleExport() {
      let dateTime = this.searchForm.getFieldValue("date_time")
      const params = {
        date_time: dateTime && dateTime.format('YYYY-MM-DD HH:mm:ss'),
        branch_id: this.searchForm.getFieldValue("branch_id"),
        is_listing: this.searchForm.getFieldValue("is_listing"),
        is_long_time_inspect: this.searchForm.getFieldValue("is_long_time_inspect"),
        is_abnormal: this.searchForm.getFieldValue("is_abnormal"),
        token: this.$ls.get(ACCESS_TOKEN),
      };
      window.open("/api/admin/stocks/check/excel" + encodeJsonToQuery(params));
    },
    handleReset() {
      this.searchForm.resetFields();
      this.queryParam = {};
      this.$refs.table.refresh();
    },
    handleChange(row) {
      this.currentRecord = { ...row };
      this.visible = true;
    },
    handleCancel() {
      this.currentRecord = {};
      this.visible = false;
    },
    _handleOk() {
      Inventory({
          id: this.currentRecord.stock_id,
          difference: this.currentRecord.difference,
        }).then((res) => {
        this.$refs.table.refresh();
        this.$message.success("提交成功");
        this.currentRecord = {};
        this.visible = false;
      });
    },
    handleSelect() {
      let routerone = this.$router.resolve({ name: "ReviewInventory" });
      window.open(routerone.href, "_blank");
    },
  },
};
</script>
<style scoped>
.pic {
  width: 50px;
  height: 50px;
}
.barcode {
  width: 150px;
  height: 50px;
}
.barcode > img {
  width: 150px;
  height: 50px;
  display: block;
}
.pic > img {
  width: 50px;
  height: 50px;
  display: block;
}
</style>
